import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Cadastral Area Filter]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)
export const setItemCollection = createAction(
    `${ SOURCE } SetItemCollection`, props<{ itemCollection: any[] }>(),
)
export const resetItemCollection = createAction(
    `${ SOURCE } ResetItemCollection`,
)
export const setFilterCriteria = createAction(
    `${ SOURCE } SetFilterCriteria`, props<{ filterCriteria: any }>(),
)
export const resetFilterCriteria = createAction(
    `${ SOURCE } ResetFilterCriteria`,
)
export const updateFilterCriteria = createAction(
    `${ SOURCE } UpdateFilterCriteria`, props<{ criteriaFragment: any }>(),
)
export const noAction = createAction(
    `${ SOURCE } No Action`,
)

export const resetSelectedAreas = createAction(
    `${ SOURCE } ResetSelectedAreas`,
)
export const toggleSelectedArea = createAction(
    `${ SOURCE } ToggleSelectedArea`, props<{ area: any }>(),
)
export const setSelectedAreas = createAction(
    `${ SOURCE } SetSelectedAreas`, props<{ selectedAreas: any }>(),
)
export const setRoute = createAction(
    `${ SOURCE } SetRoute`, props<{ route: string }>(),
)